import { createTheme } from '@mui/material/styles';

import { baseTheme, getCommonThemesProps } from './baseTheme';
import { bpcColors } from './colors/bpcColors';

export const themeBPC = () => {
  const theme = baseTheme();

  const themeProperties = getCommonThemesProps(bpcColors);
  const { palette, components } = themeProperties;

  return createTheme({
    breakpoints: theme.breakpoints,
    palette,
    components,
    customLogo: {
      logo: 'BPC_LOGO',
      slogo: 'BPC_SLOGO',
      nlogo: 'BPC_NLOGO',
    },
    verticalBreakpoints: theme.verticalBreakpoints,
    typography: theme.typography,
  });
};

// eslint-disable-next-line no-undef
if (process.env.NODE_ENV !== 'production') {
  window.theme = themeBPC();
}
